<template>
    <div class="scc-header-element">
        <div class="scc-header-element__breadcrumbs">
            <template v-for="(breadcrumb, i) in formattedBreadcrumbs">
                <span :key="'breadcrumb-' + i" class="scc-header-element__breadcrumb">{{ breadcrumb }}</span>
                <div
                    v-if="i < formattedBreadcrumbs.length - 1"
                    :key="'icon' + i"
                    class="scc-header-element__icon"
                ></div>
            </template>
        </div>
        <div class="scc-header-element__date">
            <div class="scc-header-element__date-icon"></div>
            <span class="scc-header-element__date-text bold">{{ date }}</span>
        </div>
    </div>
</template>

<script>
import './header-element.scss';

export default {
    name: 'HeaderElement',
    props: {
        breadcrumbs: {
            type: String,
            default: '',
        },
        date: {
            type: String,
            default: '',
        },
    },
    computed: {
        formattedBreadcrumbs() {
            return this.breadcrumbs?.split('/');
        },
    },
};
</script>
